import React, { useState, useEffect, useRef } from 'react';

import './whole-background.css'

export const WholeBackground = ({
    item,
    index,
    language,
    handleLanguageChange
}) => {
    const [isFixed, setIsFixed] = useState(false);
    const buttonRef = useRef(null);
    const initialPositionRef = useRef(0);

    useEffect(() => {
        if (buttonRef.current) {
            initialPositionRef.current = buttonRef.current.getBoundingClientRect().top + window.scrollY;
        }

        const handleScroll = () => {
            if (buttonRef.current) {
                const scrollY = window.scrollY;

                if (scrollY >= initialPositionRef.current) {
                    setIsFixed(true);
                } else {
                    setIsFixed(false);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    if (item.wholeBackground) {
        return (
            <div className='flex justify-between align-center section-title'>
                <h3 className='mt-0 mb-0 title'>{item.title}</h3>
                {index === 0 && (
                    <div
                        ref={buttonRef}
                        className={`flex lang-action ${isFixed ? 'fixed top-0 right-0' : ''}`}
                    >
                        <button
                            className={`toggle${language === 'English' ? ' active' : ''}`}
                            onClick={() => handleLanguageChange('English')}
                        >
                            EN
                        </button>
                        <button
                            className={`toggle${language === 'International' ? ' active' : ''}`}
                            onClick={() => handleLanguageChange('International')}
                        >
                            INT
                        </button>
                    </div>
                )}
            </div>
        );
    } else return null;
};